export const reasonOptions = [
  'From the hospital to the SNF for Admission',
  'From the SNF to the hospital for CT Scan',
  'From the SNF to hospital for MRI',
  'From the SNF to the hospital for a cardiac catheterization',
  'From the SNF to the hospital for radiation therapy',
  'From the SNF to the hospital for angiography, lymphatic, and venous services',
  'From the SNF to the hospital emergency room',
  'From the SNF to a free-standing facility for a CT Scan',
  'From the SNF to a free-standing facility for an MRI',
  'From the SNF to a free-standing facility for a cardiac catheterization',
  'From the SNF to a free-standing facility for radiation therapy',
  'From the SNF to a free-standing facility for angiography, lymphatic, and venous services',
  'From the SNF to a free-standing emergency room',
  "From the SNF to a physician's office for a CT Scan",
  "From the SNF to a physician's office for an MRI",
  "From the SNF to a physician's office for a cardiac catheterization",
  "From the SNF to a physician's office for radiation therapy",
  "From the SNF to a physician's office for angiography, lymphatic, and venous services",
  "From the SNF to the physician's office for a doctor's visit",
  'From one SNF to another SNF',
  'Other',
];

function processFacilityOptions(facilityOptions, extraOption) {
  let newOptions = [];
  if (extraOption) {
    if (facilityOptions.length > 0) {
      newOptions.push(facilityOptions[0]);
      newOptions.push(extraOption);
      newOptions = newOptions.concat(facilityOptions.slice(1));
    } else {
      newOptions.push(extraOption);
    }
  } else {
    newOptions = facilityOptions;
  }
  return newOptions.map((opt, index) => ({ ...opt, number: index + 1 }));
}

export function computeResults(formData, facilitySettings) {
  const {
    transportationType,
    primaryInsurance,
    secondaryInsurance,
    medicallyNecessary,
    reason,
  } = formData;
  let status = '';
  let extraOption = null;

  if (!medicallyNecessary) {
    if (
      transportationType === 'wheelchair' &&
      primaryInsurance === 'Medicaid'
    ) {
      status = 'Facility Pays';
    } else if (secondaryInsurance === 'Private Pay') {
      status = 'Resident Responsible';
    } else if (secondaryInsurance === 'Medicaid') {
      status = 'Facility Responsible';
    } else {
      status = 'Resident Responsible';
    }
    const facilityOptions =
      facilitySettings?.[transportationType]?.options?.[primaryInsurance] || [];
    if (
      transportationType === 'wheelchair' &&
      secondaryInsurance === 'Medicaid'
    ) {
      extraOption = { label: 'MCD Transport $0', baseCost: 0, perMile: 0 };
    }
    return {
      status,
      facilityOptions: processFacilityOptions(facilityOptions, extraOption),
    };
  }

  if (transportationType === 'stretcher') {
    // COT
    switch (primaryInsurance) {
      case 'Skilled PPO/HMO':
        status = 'Insurance Billed First - Possibly We Pay';
        break;
      case 'Private Pay':
        status = 'Patient Pays - Bill Med B or Insurance first';
        break;
      case 'Medicare(Skilled)':
        if (reason && reason.includes('A/B')) {
          status = 'Bill Part A/B';
        } else if (reason && reason.includes('SNF')) {
          status = 'Facility Responsible';
        } else {
          status = 'Reason selection required';
        }
        break;
      case 'MED A HMO(Skilled)':
        if (reason && reason.includes('A/B')) {
          status =
            'We Pay if not excluded. Same as Med A. Higher possibility we pay';
        } else if (reason && reason.includes('SNF')) {
          status = 'Facility Responsible';
        } else {
          status = 'Reason selection required';
        }
        break;
      case 'Medicaid':
        status = 'MCD Pays if Medically Necessary';
        extraOption = { label: 'MCD Transport $0', baseCost: 0, perMile: 0 };
        break;
      case 'Anthem':
        status = 'Call Ins TX 1-844-912-0938';
        break;
      case 'Aetna':
        status = 'Call Ins TX 1-855-364-0974 at least 3 days prior';
        break;
      case 'Buckeye':
        status = 'Call Ins TX 1-866-549-8289 #3 1-866-531-0615';
        break;
      case 'Molina':
        status =
          'Call Ins TX 1-844-491-4761 1-844-229-2688 at least 3 days prior';
        break;
      case 'UHC Commercial':
        status = 'UHC Pays Call Commercial 1-855-544-4342';
        break;
      case 'UHC Dual':
        status =
          'UHC pays call dual\n1-800-600-9007 Plan Benefits\n1-800-269-4190 scheduling\nat least 3 days prior';
        break;
      case 'Humana':
        status = 'Call Humana TX 1-877-856-5702';
        break;
      case 'Care Source':
        status = 'Call Ins TX 1-855-475-3163 at least 48 hours prior';
        break;
      default:
        status = 'Insurance information incomplete';
    }
    const facilityOptions =
      facilitySettings?.[transportationType]?.options?.[primaryInsurance] || [];
    return {
      status,
      facilityOptions: processFacilityOptions(facilityOptions, extraOption),
    };
  } else if (transportationType === 'wheelchair') {
    // WC
    switch (primaryInsurance) {
      case 'Skilled PPO/HMO':
        if (secondaryInsurance === 'Private Pay') {
          status = 'Resident Responsible';
        } else if (secondaryInsurance === 'Medicaid') {
          status = 'Medicaid Responsible';
          extraOption = { label: 'MCD Transport $0', baseCost: 0, perMile: 0 };
        } else {
          status = 'Incorrect secondary insurance';
        }
        break;
      case 'Private Pay':
        status = 'Patient Responsible';
        break;
      case 'Medicare(Skilled)':
        if (secondaryInsurance === 'Private Pay') {
          status = 'Resident Responsible';
        } else if (secondaryInsurance === 'Medicaid') {
          status = 'Medicaid Responsible';
          extraOption = { label: 'MCD Transport $0', baseCost: 0, perMile: 0 };
        } else {
          status = 'Incorrect secondary insurance';
        }
        break;
      case 'MED A HMO(Skilled)':
        if (secondaryInsurance === 'Private Pay') {
          status = 'Resident Responsible';
        } else if (secondaryInsurance === 'Medicaid') {
          status = 'Medicaid Responsible';
          extraOption = { label: 'MCD Transport $0', baseCost: 0, perMile: 0 };
        } else {
          status = 'Incorrect secondary insurance';
        }
        break;
      case 'Medicaid':
        status = 'Medicaid Pays. Medical Necessity form needed';
        extraOption = { label: 'MCD Transport $0', baseCost: 0, perMile: 0 };
        break;
      case 'Anthem':
        status = 'Call Ins TX 1-844-912-0938';
        break;
      case 'Aetna':
        status = 'Call Ins TX 1-855-364-0974 at least 3 days prior';
        break;
      case 'Buckeye':
        status = 'Call Ins TX 1-866-549-8289 #3 1-866-531-0615';
        break;
      case 'Molina':
        status =
          'Call Ins TX 1-844-491-4761 1-844-229-2688 at least 3 days prior';
        break;
      case 'UHC Commercial':
        status = 'UHC Pays Call Commercial 1-855-544-4342';
        break;
      case 'UHC Dual':
        status =
          'UHC pays call dual\n1-800-600-9007 Plan Benefits\n1-800-269-4190 scheduling\nat least 3 days prior';
        break;
      case 'Humana':
        status = 'Call Humana TX 1-877-856-5702';
        break;
      case 'Care Source':
        status = 'Call Ins TX 1-855-475-3163 at least 48 hours prior';
        break;
      default:
        status = 'Please contact insurance for details';
    }
    const facilityOptions =
      facilitySettings?.[transportationType]?.options?.[primaryInsurance] || [];
    return {
      status,
      facilityOptions: processFacilityOptions(facilityOptions, extraOption),
    };
  } else {
    return { status: 'Invalid transportation type', facilityOptions: [] };
  }
}
